export function createIdentityApi(http) {
  return {
    login: (email, password) => http.post("/login", { email, password }),
    logout: () => http.post("/logout"),
    refreshToken: (token) =>
      http.post("/token/refresh", null, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    currentUser: () => http.get("/user"),
    updateProfile: (data) => http.put("/profile", data),
    listUsers: (params) => params ? http.get("/users", { params }) : http.get("/users"),
    createUser: (data) => http.post("/register", data),
    updateUser: (userId, data) => http.put(`/users/${userId}`, data),
    listEmployeeHierarchy: () => http.get("/brigady/list"),
    listLeaders: () => http.get("/brigady/listbrygadzisci"),
    listBrigades: () => http.get("/brigady/index"),
    assignEmployee: (data) => http.post("/brigady/assign", data),
    listLeaderEmployees: (leaderId) =>
      http.get(`/brigady/${leaderId}/employees`),
  };
}
